import { render } from "./SecteurLivraison.vue?vue&type=template&id=164be1cc"
import script from "./SecteurLivraison.vue?vue&type=script&lang=js"
export * from "./SecteurLivraison.vue?vue&type=script&lang=js"

import "./SecteurLivraison.vue?vue&type=style&index=0&id=164be1cc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__